import { Box, List } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useParams, useSearchParams } from "react-router-dom";
import { useAppSelector } from "../../../../app/hooks";
import LoadingSpinner from "../../../../common/components/functional/loadingSpinner/LoadingSpinner";
import { selectAllCustomerContracts } from "../../customerContractsSlice";
import { CustomerOrganizationsResult } from "../../types/queries";
import ListItemComponent from "../ListItemComponent";
import { ListHeader } from "../styles";
import AddButton from "../../../../common/components/functional/addButton/AddButton";
import { TabValue } from "../../types/types";
import { canExpertAddContract } from "../../../user/accessRightChecks";
import { useState } from "react";
import { CreateCustomerContractDialog } from "../../create/contract/CreateCustomerContractDialog";

type Props = {
  representativeOrganization: CustomerOrganizationsResult;
  selectedTab: TabValue;
};

const EezyCompanyFilter = ({
  representativeOrganization,
  selectedTab,
}: Props) => {
  const { t } = useTranslation("customers");
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedEezyCompanyId = searchParams.get("ecom");
  const selectedCustomerOrgId = searchParams.get("org");
  const { customerCompanyId } = useParams();

  const { status } = useAppSelector((state) => state.customerContracts);
  const isLoading = status === "pending";
  const customerContracts = useAppSelector((state) =>
    selectAllCustomerContracts(state),
  ).sort((a, b) => a.id.localeCompare(b.id));

  const [isContractDialogOpen, setIsContractDialogOpen] = useState(false);

  const handleFilterChange = (contract: any) => {
    const orgId =
      selectedCustomerOrgId && selectedCustomerOrgId !== "null"
        ? selectedCustomerOrgId
        : representativeOrganization?.id;
    setSearchParams({
      ...(orgId && { org: orgId }),
      ecom: contract.eezyCompany.id,
    });
  };

  return (
    <>
      <Box flex={1} maxWidth="295px">
        <List
          sx={{ marginTop: "22px", width: "100%", maxWidth: "311px" }}
          subheader={<ListHeader variant="header">{t("companies")}</ListHeader>}
        >
          <ListItemComponent
            key={representativeOrganization?.id}
            primary={representativeOrganization?.name}
            secondary={representativeOrganization?.businessId}
            selected={false}
            onClick={() => {}}
            disabled
            sx={{
              marginTop: "0.5rem",
              marginLeft: "unset",
              borderBottom: "none",
            }}
          />
          {isLoading ? (
            <LoadingSpinner />
          ) : (
            customerContracts.map((contract) => {
              const isSelected =
                contract.eezyCompany.id === selectedEezyCompanyId;
              return (
                <ListItemComponent
                  key={contract.eezyCompany.id}
                  primary={contract.eezyCompany.name}
                  secondary={contract.eezyCompany.businessId}
                  selected={isSelected}
                  onClick={() => handleFilterChange(contract)}
                  sx={{
                    marginTop: "unset",
                    marginLeft: "24px",
                    borderBottom: isSelected ? "none" : "1px solid #000A441C",
                  }}
                />
              );
            })
          )}
          {selectedTab === "contracts" && (
            <AddButton
              sx={{ marginTop: "1rem", marginLeft: "32px" }}
              label={t("invoices:contract")}
              onClick={() => setIsContractDialogOpen(true)}
              variant="contained"
              accessRightChecks={[canExpertAddContract]}
            />
          )}
        </List>
      </Box>
      <CreateCustomerContractDialog
        customerCompany={{
          id: customerCompanyId || "",
          name: representativeOrganization?.name,
        }}
        open={isContractDialogOpen}
        onClose={() => setIsContractDialogOpen(false)}
      />
    </>
  );
};

export default EezyCompanyFilter;
